<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="导入用户列表" name="user">
                    <User v-if="activeName=='user'"></User>
                </el-tab-pane>
                <el-tab-pane label="等级权限列表" name="role">
                    <Role v-if="activeName=='role'"></Role>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import User from './user/Index.vue';
    import Role from './role/Index.vue';
    export default {
        components: {
            User,
            Role
        },
        data() {
            return {
                activeName: 'user',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {
            // 默认
            let activeName = this.$db.getRouteField(this, 'tab_active');
            if (activeName) this.activeName = activeName;

        },
        methods: {
            handleClick(tab, event) {
                this.$db.setRoute(this, {'tab_active': tab.name});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/study/importuser/index.vue